// extracted by mini-css-extract-plugin
export default {"clock":"AttentionMsg_clock__vyy5b"};